/**
 * Turn an APIAgent error into a message safe to render.
 *
 * FastAPI dict-shaped `detail` bodies (e.g. the QA T-29 409
 * `listing_not_tourable` gate) reach us JSON-stringified in `err.message`;
 * without this the user would see raw JSON in the error banner.
 *
 * @param {Error} err - Error thrown by APIAgent.request.
 * @param {string} fallback - Message used when the error carries none.
 * @returns {string} Human-readable message.
 */
export default function tourErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const raw = err?.message || fallback;
  if (typeof raw !== 'string' || !raw.trim().startsWith('{')) return raw;
  try {
    const parsed = JSON.parse(raw);
    return parsed?.message || raw;
  } catch (_) {
    return raw;
  }
}
